import { EuiSpacer } from '@elastic/eui';
import VideoCard from "../../../../src/components/Advanced_User/Videos/video-hd-firmware-recover-winxp";
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard,
  React
};